import mutations from '../mutations';
import api from '../../api';

export default {
  namespaced: true,
  state: {
    loading: false
  },
  mutations: {
    [mutations.LOADING](state) {
      state.loading = true;
    },
    [mutations.LOADED](state) {
      state.loading = false;
    }
  },
  actions: {
    getGroup({ commit }, id) {
      commit(mutations.LOADING);
      return api.approval
        .getGroup(id)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    createApproval({ commit }, payload) {
      commit(mutations.LOADING);
      return api.approval
        .createApproval(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    detailApprover({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.approval
        .detailApprover(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    updateCondition({ commit }, payload) {
      commit(mutations.LOADING);
      return api.approval
        .updateCondition(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    deleteCondition({ commit }, id) {
      commit(mutations.LOADING);
      return api.approval
        .deleteCondition(id)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    approveIO({ commit }, payload) {
      commit(mutations.LOADING);
      return api.approval
        .approveIO(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    updateNotes({ commit }, payload) {
      commit(mutations.LOADING);
      return api.approval
        .updateNotes(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    rejectIO({ commit }, payload) {
      commit(mutations.LOADING);
      return api.approval
        .rejectIO(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    approveGroupBO({ commit }, payload) {
      commit(mutations.LOADING);
      return api.approval
        .approveGroupBO(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    rejectGroupBO({ commit }, payload) {
      commit(mutations.LOADING);
      return api.approval
        .rejectGroupBO(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    getBO({ commit }, id) {
      commit(mutations.LOADING);
      return api.approval
        .getBO(id)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    approveHouse({ commit }, payload) {
      commit(mutations.LOADING);
      return api.approval
        .approveHouse(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    rejectHouse({ commit }, payload) {
      commit(mutations.LOADING);
      return api.approval
        .rejectHouse(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    getConfigEmail({ commit }) {
      commit(mutations.LOADING);
      return api.approval
        .getConfigEmail()
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    setConfigEmail({ commit }, payload) {
      commit(mutations.LOADING);
      return api.approval
        .setConfigEmail(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    }
  },
  getters: {
    isLoggedIn: state => state.isLoggedIn,
    user: state => state.user,
    token: state => state.token,
    isLoading: state => state.loading,
    error: state => {
      if (state.error && state.error.response) {
        return state.error.response.data;
      }
      return state.error;
    }
  }
};
